import React from 'react';
import { StorageBoxFolderIcon } from '../utils/storageBoxFolderIcon';
import { resolveStorageBoxFileIcon } from '../utils/storageBoxFileIcon';

export default function DriveItemIcon({ item, className = '' }) {
  if (item?.type === 'folder') {
    return (
      <StorageBoxFolderIcon
        name={item?.name}
        folderColor={item?.folderColor}
        className={className}
      />
    );
  }
  const { Icon, modifierClass } = resolveStorageBoxFileIcon(item?.mimeType, item?.name);
  const classes = ['sb-drive-icon', modifierClass, className].filter(Boolean).join(' ');
  return <Icon className={classes} aria-hidden />;
}
